webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Map__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Map__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Map',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Map___default.a
  }]
}));

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(29)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(12),
  /* template */
  __webpack_require__(32),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(8);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var Cell = function () {
  function Cell() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Cell);

    this.r = Math.floor(Math.random() * 255);
    this.g = Math.floor(Math.random() * 255);
    this.b = Math.floor(Math.random() * 255);
  }
  /**
   * スタイルオブジェクトの取得(背景色)
   * @return Object スタイルオブジェクト
   */


  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Cell, [{
    key: 'getStyle',
    value: function getStyle() {
      return {
        'background-color': 'rgb(' + this.r + ',' + this.g + ',' + this.b + ')'
      };
    }

    /**
     * セルの色と引数の色との距離を計算する
     * @param  Number r red
     * @param  Number g green
     * @param  Number b blue
     * @return Number   色距離
     */

  }, {
    key: 'caclColorDistance',
    value: function caclColorDistance(r, g, b) {
      return Math.pow(this.r - r, 2) + Math.pow(this.g - g, 2) + Math.pow(this.b - b, 2);
    }

    /**
     * 現在のセルの色に指定色を混ぜる
     * @param  Number r     red
     * @param  Number g     green
     * @param  Number b     blue
     * @param  Number ratio 混色比率(0～1.0)
     * @return void
     */

  }, {
    key: 'mixColor',
    value: function mixColor(r, g, b, ratio) {
      this.r = Math.floor(this.r * (1 - ratio) + r * ratio);
      this.g = Math.floor(this.g * (1 - ratio) + g * ratio);
      this.b = Math.floor(this.b * (1 - ratio) + b * ratio);
    }
  }]);

  return Cell;
}();

/* harmony default export */ __webpack_exports__["a"] = (Cell);

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model_Cell__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      width: 10,
      height: 10,
      count: 1000,
      cells: []
    };
  },
  created: function created() {
    this.init();
  },

  methods: {
    init: function init() {
      this.cells = [];
      for (var y = 0; y < this.height; y++) {
        this.cells.push([]);
        for (var x = 0; x < this.width; x++) {
          this.cells[y].push(new __WEBPACK_IMPORTED_MODULE_0__model_Cell__["a" /* default */]());
        }
      }
    },
    execute: function execute() {
      for (var i = 0; i < this.count; i++) {
        var r = Math.floor(Math.random() * 255);
        var g = Math.floor(Math.random() * 255);
        var b = Math.floor(Math.random() * 255);
        var bmu = this.searchBMU(r, g, b);
        this.expose(bmu, r, g, b);
      }
    },
    searchBMU: function searchBMU(r, g, b) {
      var bmu = {
        x: 0,
        y: 0,
        distance: this.cells[0][0].caclColorDistance(r, g, b)
      };
      for (var y = 0; y < this.height; y++) {
        for (var x = 0; x < this.width; x++) {
          var distance = this.cells[y][x].caclColorDistance(r, g, b);
          if (distance < bmu.distance) {
            bmu.x = x;
            bmu.y = y;
            bmu.distance = distance;
          }
          if (distance === 0) {
            break;
          }
        }
      }
      return bmu;
    },
    expose: function expose(bmu, r, g, b) {
      for (var h = -1; h <= 1; h++) {
        for (var w = -1; w <= 1; w++) {
          var x = Math.min(Math.max(bmu.x + w, 0), this.width - 1);
          var y = Math.min(Math.max(bmu.y + h, 0), this.height - 1);
          this.cells[y][x].mixColor(r, g, b, 0.1);
        }
      }
    }
  }
});

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 29 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(28)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(13),
  /* template */
  __webpack_require__(31),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_vm._v("\n    w:\n    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.width),
      expression: "width"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.width)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.width = $event.target.value
      }
    }
  }), _vm._v("\n    h:\n    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.height),
      expression: "height"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.height)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.height = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.init()
      }
    }
  }, [_vm._v("init")])]), _vm._v(" "), _c('div', [_vm._v("\n    step:\n    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.count),
      expression: "count"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.count)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.count = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.execute()
      }
    }
  }, [_vm._v("execute")])]), _vm._v(" "), _c('table', _vm._l((_vm.cells), function(line) {
    return _c('tr', _vm._l((line), function(cell) {
      return _c('td', [_c('div', {
        staticClass: "cell",
        style: (cell.getStyle())
      })])
    }))
  }))])
},staticRenderFns: []}

/***/ }),
/* 32 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ })
],[10]);


// WEBPACK FOOTER //
// static/js/app.f329baae953272353cf6.js